<template>
  <MetricTile
    :loading="loading"
    :no-data="!metric || !metric.completed"
    color="red"
    :options="{
      showAdditionalData: true
    }"
    icon="fa-solid fa-face-smile"
  >
    <template #title>{{ $t("components.Big5CompletionRatioMetricTile.title") }}</template>
    <template #metric-title>{{ $t("components.Big5CompletionRatioMetricTile.metric_title") }}</template>
    <template #metric>{{ metric.completed }}</template>
    <template #overMetric>{{ metric.total }} </template>

    <template #additionalMetric> {{ metric.percentage }}%</template>
    <template #info>{{ $t("components.Big5CompletionRatioMetricTile.info") }}</template>
  </MetricTile>
</template>

<script setup lang="ts">
import MetricTile from "@/components/Metrics/MetricTile.vue";
import {useMetricTile} from "@/composables/useMetricTile";
const { metric, loading } = useMetricTile<{
  completed: number;
  total: number;
  percentage: number;
  additionalData?: Record<string, unknown>;
}>("users-completed-big5-ratio");
</script>

<style scoped>

</style>
